<template>
    <div class="home">
        <div class="positioning"></div>
        <div class="home-content">
            <AnimatedContent :use-scroll-trigger="false" :delay="0.1">
                <div class="home-title">{{ $t('home.dataUpdate') }}</div>
                <div class="home-desc">
                    <div class="home-desc-l">{{ nowTime }} <span>UTC+8</span></div>
                    <div class="home-desc-r">
                        <div class="point"></div>
                        <span>{{ $t('home.realtime') }}</span>
                    </div>
                </div>
            </AnimatedContent>

            <AnimatedContent :use-scroll-trigger="false" :delay="0.2">
                <div class="home-card">
                    <div class="home-card-t">
                        <div>
                            <div class="home-card-t-title">
                                {{ $t('home.totalRevenue') }}
                            </div>
                            <div class="home-card-t-number">
                                <NumberScroll :to="totalRewards" :decimal="true" :decimalDigits="2" separator="," />
                            </div>
                            <div class="home-card-t-revenue">
                                <img src="../../assets/img/home/arrow-b.png" alt="">
                                {{ $t('home.today') }} +{{dayRewards}}
                                <!-- <span> +3.45%</span> -->
                            </div>
                        </div>
                        <div>
                            <img class="echart" src="../../assets/img/home/echart.png" alt="">
                        </div>
                    </div>

                    <div class="line"></div>
                    <div class="home-card-b">
                        <div>
                            <div class="home-card-b-title">
                                {{ $t('home.totalTradingVolume') }}
                            </div>
                            <div class="home-card-b-number">
                                <NumberScroll class="num" :to="totalPledge" :decimal="false" :decimalDigits="0"
                                    separator="," />
                                <i>USDT</i>
                            </div>
                        </div>
                        <div class="today">
                            <div class="home-card-b-title">
                                {{ $t('home.todayEarn') }}
                            </div>
                            <div class="home-card-b-number today">
                                <NumberScroll class="num" :to="dayRewards" :decimal="true" :decimalDigits="2" />
                                <i>USDT</i>
                            </div>
                        </div>
                    </div>
                </div>
            </AnimatedContent>

            <AnimatedContent :use-scroll-trigger="false" :delay="0.3">
                <div class="home-share">
                    <div class="home-share-l">
                        <img src="../../assets/img/home/icon1.png" alt="">
                        <span>{{ $t('home.share') }}</span>
                    </div>
                    <div class="home-share-r" @click="openShareFriends()">
                        <span>{{ $t('home.shareDesc') }}</span>
                        <img src="../../assets/img/home/arrow-r.png" alt="">
                    </div>
                </div>
            </AnimatedContent>

            <AnimatedContent :use-scroll-trigger="false" :delay="0.4">
                <div class="home-card1">
                    <div>
                        <div class="title">
                            <span>{{ $t('home.directReferrals') }}</span>
                            <img src="../../assets/img/home/icon2.png" alt="">
                        </div>
                        <div class="num">
                            <NumberScroll :to="recommandCount" />
                        </div>
                        <div class="revenue">{{ $t('home.thisWeek') }} <span>+{{weekRecommandCount}}</span></div>
                    </div>
                    <div>
                        <div class="title">
                            <span>{{ $t('home.teamMembers') }}</span>
                            <img src="../../assets/img/home/icon3.png" alt="">
                        </div>
                        <div class="num">
                            <NumberScroll :to="teamCount" separator="," />
                        </div>
                        <div class="revenue">{{ $t('home.thisWeek') }} <span>+{{weekTeamCount}}</span></div>
                    </div>
                </div>
            </AnimatedContent>

            <AnimatedContent :use-scroll-trigger="false" :delay="0.5">
                <div class="home-link">
                    <div class="home-link-l">
                        {{domainurl}}/#/home
                    </div>
                    <div class="home-link-r" @click="copyShre()">
                        <img src="../../assets/img/home/icon4.png" alt="">
                        <span>{{ $t('home.copy') }}</span>
                    </div>
                </div>
            </AnimatedContent>

            <AnimatedContent :use-scroll-trigger="false" :delay="0.6">
                <div class="home-btn-box">

                    <StarBorder color="#17CFDC" as="div">
                        <div class="btn-task" @click="toport()">
                            <img src="../../assets/img/home/icon5.png" alt="">
                            {{ $t('port.dailyTask') }}
                        </div>
                    </StarBorder>
                    <div class="btn-revenue-box">
                        <StarBorder color="#DAFE96" as="div">
                            <div class="btn-revenue" @click="toRecently()">
                                <img src="../../assets/img/home/icon6.png" alt="">
                                {{ $t('home.recently') }}
                            </div>
                        </StarBorder>
                    </div>
                </div>
            </AnimatedContent>

            <AnimatedContent :use-scroll-trigger="false" :delay="0.7">
                <div class="home-list">
                    <div class="home-list-title">
                        <div>{{ $t('home.recently') }}</div>
                        <div class="link" @click="toRecently()">{{ $t('home.all') }}
                            <img src="../../assets/img/home/icon7.png" alt="">
                        </div>
                    </div>
                    <div class="line"></div>
                    <div class="home-list-item" v-for="(item,i) in datalist" :key="i">
                        <div class="home-list-item-l">
                            <img :src="getIcon(item.Remark)" alt="">
                            <div>
                                <div class="title">{{ getRewardRemark(item.Remark) }}</div>
                                <div class="time">{{item.AddTime.replace('T',' ').slice(0,19)}}</div>
                            </div>
                        </div>
                        <div class="home-list-item-r">{{item.AccountType}} {{item.Amount}} USDT</div>
                    </div>

                </div>
            </AnimatedContent>
        </div>
        <!-- 分享给朋友 -->
        <Popup v-model="show" get-container="#app" :close-on-click-overlay="false" class="home-share-popup-box"
            position="center">
            <div class="home-share-popup">
                <div class="home-share-popup-card">
                    <div class="home-share-popup-card-t">
                        <img src="../../assets/img/layout/logo.png" alt="">
                        <div>
                            <div>{{ $t('home.myProfit') }}</div>
                            <img @click="show = false" src="../../assets/img/home/close.png" alt="">
                        </div>
                    </div>
                    <div class="desc">
                        {{ $t('home.earningOnBitDeep') }}
                    </div>
                    <div class="num">
                        <NumberScroll :to="totalRewards" :decimal="true" :decimalDigits="2" separator="," />
                    </div>
                    <div class="desc">
                        {{ $t('home.totalRevenueUsdt') }}
                    </div>
                    <div class="echart">
                        <img src="../../assets/img/home/icon.png" alt="">

                    </div>
                    <div class="revenue">
                        <div>
                            <div class="label ">{{ $t('home.today') }}</div>
                            <div class="value yellow">+
                                <NumberScroll :to="dayRewards" :decimal="true" :decimalDigits="2" />
                            </div>
                        </div>
                        <div>
                            <div class="label ">{{ $t('home.today') }}{{ $t('home.staticrewares') }}</div>
                            <div class="value yellow">+
                                <NumberScroll :to="dayStatic" :decimal="true" :decimalDigits="1" />%
                            </div>
                        </div>
                        <div>
                            <div class="label ">{{ $t('home.consecutiveDays') }}</div>
                            <div class="value yellow">
                                <NumberScroll :to="totaldays" />
                            </div>
                        </div>
                    </div>

                    <div class="qr">
                        <!-- <img src="" alt=""> -->
                        <img v-if="qrCodeUrl" :src="qrCodeUrl" alt="QR Code" class="qrcode-img">

                        <div class="qr-r">
                            <div class="label">{{ $t('home.scanToJoin') }}</div>
                            <div class="value">{{domainurl}}<span></span></div>
                            <div class="uid">{{ $t('home.uid') }} · {{MemberNo}} · </div>
                        </div>
                    </div>
                </div>

                <div class="home-share-popup-card1">
                    <div class="home-share-popup-card1-t">
                        <div>{{ $t('home.shareTo') }}</div>
                        <span>{{ $t('home.eachReferral') }}</span>
                    </div>
                    <div class="home-share-popup-card1-c">
                        <div>
                            <img src="../../assets/img/home/telegram.png" alt="">
                            <div>Telegram</div>
                        </div>

                        <div>
                            <img src="../../assets/img/home/x.png" alt="">
                            <div>
                                X
                                <div>(Twitter)</div>
                            </div>
                        </div>

                        <div>
                            <img src="../../assets/img/home/whatsapp.png" alt="">
                            <div>
                                WhatsApp
                            </div>
                        </div>
                        <div>
                            <img src="../../assets/img/home/discord.png" alt="">
                            <div>
                                Discord
                            </div>
                        </div>
                        <div>
                            <img src="../../assets/img/home/wx.png" alt="">
                            <div>
                                WeChat
                            </div>
                        </div>
                    </div>
                    <div class="btn">
                        <StarBorder color="#17CFDC" as="div">
                            <div class="copyLink" @click="copyShareLink()">
                                <img src="../../assets/img/home/copy.png" alt="">
                                {{ $t('popup.copyLink') }}
                            </div>
                        </StarBorder>
                        <StarBorder color="#17CFDC" as="div">
                            <div class="active download">
                                <img src="../../assets/img/home/down1.png" alt="">
                                {{ $t('home.downloadPdf') }}
                            </div>
                        </StarBorder>
                    </div>

                </div>
            </div>
        </Popup>

        <!-- 复制链接 -->
        <Popup v-model="copyLinkShow" get-container="#app" :close-on-click-overlay="false" class="home-link-popup-box"
            position="center">
            <div class="home-link-popup">
                <img class="home-link-popup-close" @click="copyLinkShow = false" src="../../assets/img/home/close.png"
                    alt="">
                <div class="home-link-popup-t">
                    <div>{{ $t('popup.shareTitle') }}</div>
                </div>
                <div class="title">
                    BitDeep PoRT{{ $t('port.portTaskCenter') }}
                </div>
                <div class="desc">
                    {{ $t('popup.shareDesc') }}
                </div>

                <div class="qr-box">
                    <div class="corner top-left"></div>
                    <div class="corner top-right"></div>
                    <div class="corner bottom-left"></div>
                    <div class="corner bottom-right"></div>
                    <div class="qr-content">
                        <img v-if="qrCodeUrl" :src="qrCodeUrl" alt="QR Code" class="qrcode-img">
                        <div v-else class="placeholder"></div>
                    </div>
                </div>

                <div class="share-action">
                    <img src="../../assets/img/home/qr.png" alt="">
                    <span>{{ $t('home.screenshotAndShare') }}</span>
                </div>
                <div class="share-tip">{{ $t('home.saveShareEarn') }}</div>

                <div class="link-row">
                    <div class="link-left">
                        <img src="../../assets/img/home/bitt.png" alt="">
                        {{domainurl}}<span></span>
                    </div>
                    <div class="link-right">UID {{MemberNo}}</div>
                </div>

                <div class="btn-group">
                    <StarBorder color="#17CFDC" as="div">
                        <div class="btn copy" @click="copyShareLink()">
                            <img src="../../assets/img/home/copy.png" alt="">
                            <span>{{ $t('popup.copyLink') }}</span>
                        </div>

                    </StarBorder>
                    <StarBorder color="#17CFDC" as="div" >
                        <div class="btn save">
                            <img src="../../assets/img/home/down1.png" alt="">
                            <span>{{ $t('home.downloadPdf') }} {{ $t('popup.qrCode') }}</span>
                        </div>
                    </StarBorder>
                </div>

                <div class="line"></div>

                <div class="reward-tier" v-if="false">
                    <div class="tier-item">
                        <div class="tier-label blue">L1</div>
                        <div class="tier-desc">{{ $t('popup.rewardTier1') }}</div>
                    </div>
                    <div class="tier-divider"></div>
                    <div class="tier-item">
                        <div class="tier-label yellow">L2-L7</div>
                        <div class="tier-desc">{{ $t('popup.rewardTier2') }}</div>
                    </div>
                    <div class="tier-divider"></div>
                    <div class="tier-item">
                        <div class="tier-label">∞</div>
                        <div class="tier-desc">{{ $t('popup.rewardTier3') }}</div>
                    </div>
                </div>
            </div>
        </Popup>


    </div>
</template>

<script>
import { Popup } from 'vant'
import NumberScroll from '@/components/NumberScroll.vue'
import AnimatedContent from '@/components/AnimatedContent/AnimatedContent.vue'
import StarBorder from '@/components/StarBorder/StarBorder.vue'
import QRCode from 'qrcode'
import { copyToClipboard } from "@/utils";

import axios from 'axios'
import contractaa from '../contract/index.js';



export default {
    components: {
        Popup,
        NumberScroll,
        AnimatedContent,
        StarBorder
    },
    name: 'home',
    data() {
        return {
            //分享给朋友
            show: false,
            //分享推荐人
            copyLinkShow: false,
       
            qrCodeUrl: '',
            //总收益
            totalRewards:0,
            //今日收益
            dayRewards:0,
            totalPledge:0,
            MemberNo:'',
            recommandCount:0,
            weekRecommandCount:0,
            teamCount:0,
            weekTeamCount:0,
            totaldays:0,
            dayStatic:0,
            shareLink:'',
            domainurl:'https://getbitdeep.com',

            nowTime:'',
            timer:null,

            datalist:[]


        }
    },
    methods: {
        formatTime(){

            const d = new Date()

            const Y = d.getFullYear()

            const M = String(
                d.getMonth()+1
            ).padStart(2,'0')

            const D = String(
                d.getDate()
            ).padStart(2,'0')

            const H = String(
                d.getHours()
            ).padStart(2,'0')

            const I = String(
                d.getMinutes()
            ).padStart(2,'0')

            const S = String(
                d.getSeconds()
            ).padStart(2,'0')

            this.nowTime =
            `${Y}-${M}-${D} ${H}:${I}:${S}`

        },
        toRecently() {
            this.$router.push({ name: 'recently' })
        },
        toport() {
            this.$router.push({ name: 'port' })
        },
        copyShareLink() {
            copyToClipboard(this.shareLink)
            this.$toast.success(this.$t('withdraw.withdrawSuccess'))
        },
        generateQRCode(v) {
            const link = this.domainurl+'/#/home?_needChain=bnb&share='+v
           this.shareLink = link
           QRCode.toDataURL(link, {
                width: 200,
                margin: 0,
                color: {
                    dark: '#FFFFFF',
                    light: '#0C0F14'
                }
            }, (error, url) => {
                if (error) {
                    console.error(error)
                    return
                }
                this.qrCodeUrl = url
            })
        },
        //分享连接
        copyShre(){
            this.copyLinkShow = true

        },

        //分享好友
        openShareFriends(){
            this.show = true
        },
        getIcon(v){
            if(v=="静态收益"){
                return require(`@/assets/img/home/icon8.png`)
            }else if(v=="伯乐奖"){
                return require(`@/assets/img/home/icon9.png`)
            }else if(v=="极差奖"){
                return require(`@/assets/img/home/icon10.png`)
            }else if(v=="平级奖"){
                return require(`@/assets/img/home/icon11.png`)
            }else if(v=="全球分红"){
                return require(`@/assets/img/home/icon12.png`)
            }else if(v=="提现"){
                return require(`@/assets/img/home/icon13.png`)
            }else if(v=="PoRT 任务通过"){
                return require(`@/assets/img/home/icon11.png`)
            }else{
                return require(`@/assets/img/home/icon9.png`)
            }
        },
        getRewardRemark(v){
            if(v=="全球分红"){
                return  this.$t('port.rewardRemark1') 
            }else if(v=="级差奖"){
                 return  this.$t('port.rewardRemark2') 
            }else if(v=="平级奖"){
                 return  this.$t('port.rewardRemark2') 
            }else if(v=="伯乐奖"){
                 return  this.$t('port.rewardRemark3') 
            }else if(v=="任务奖励"){
                 return  this.$t('port.rewardRemark4') 
            }else if(v=="PoRT 任务通过"){
                return this.$t('port.rewardRemark5') 
            }
        },
        async getInfo(){
            var that = this;
            let useraddr = that.$store.state.globalAddress
            const result = await axios.post(contractaa.APIURL+'?cmd=home',"addr="+useraddr)
            if(result.status==200){
                let data = result.data
                if(data.Status){
                    //console.log(data.Message)
                    let _arr = data.Message.split('|')
                    that.totalRewards = Number(_arr[2])
                    that.dayRewards = Number(_arr[1])
                    that.totalPledge = Number(_arr[0])
                    that.MemberNo = (_arr[5])
                    that.recommandCount = Number(_arr[6])
                    that.teamCount = Number(_arr[7])
                    that.weekRecommandCount = Number(_arr[8])
                    that.weekTeamCount = Number(_arr[9])
                    that.totaldays = Number(_arr[4])
                    that.dayStatic = Number(_arr[3])

                    that.datalist = data.Data
                    that.generateQRCode(that.MemberNo)
                }else{
                    that.$toast.fail(that.$t('withdraw.withdrawFailed') )
                }
            }else{
                that.$toast.fail(that.$t('withdraw.withdrawFailed'))
            }
            //console.log(result)
                    
        }
    },
    mounted(){
        this.formatTime()

        this.timer = setInterval(()=>{

            this.formatTime()

        },1000)

        this.getInfo()
    },
    beforeDestroy(){

        clearInterval(this.timer)

    }
}
</script>

<style scoped lang="less">
.home {
    position: relative;

    .positioning {
        height: 61px;
    }

    .home-title {
        font-weight: 400;
        font-size: 11px;
        color: #FFFFFF;
        line-height: 16px;
        opacity: 0.5;
    }

    .home-content {
        padding: 10px 15px 50px;

        .home-desc {
            margin-top: 6px;
            display: flex;
            justify-content: space-between;
            font-weight: 400;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 20px;

            span {
                color: rgba(0, 240, 255, 1);
            }

            &-l {
                span {
                    margin-left: 6px;
                }
            }

            &-r {
                display: flex;
                align-items: center;

                .point {
                    width: 6px;
                    height: 6px;
                    background: #00F0FF;
                    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.5);
                    border-radius: 50%;
                    margin-right: 6px;
                }

                span {
                    font-size: 12px;
                    color: #9FF3FF;
                }
            }
        }

        .home-card {
            padding: 15px;
            margin-top: 15px;
            background: url('../../assets/img/home/card-bg.png') no-repeat;
            background-size: 100% 100%;
            min-height: 219px;

            .home-card-t {
                display: flex;
                justify-content: space-between;

                .echart {
                    margin-top: 4px;
                    width: 114px;
                    height: 62px;
                }

                .home-card-t-title {
                    font-size: 12px;
                    color: #FFFFFF;
                    line-height: 17px;
                    opacity: 0.5;
                }

                .home-card-t-number {
                    font-family: DINAlternate, DINAlternate;
                    font-weight: bold;
                    font-size: 36px;
                    color: #FFFFFF;
                    line-height: 42px;
                    background: linear-gradient(0deg, #EBFEFF 0%, #00F0FF 100%);
                    -webkit-background-clip: text;
                    background-clip: text;
                    color: transparent;
                }

                .home-card-t-revenue {
                    font-weight: 500;
                    margin-top: 10px;
                    font-size: 11px;
                    color: #E8FFB1;
                    line-height: 16px;
                    display: flex;
                    align-items: center;

                    >img {
                        width: 8px;
                        height: 8px;
                        margin-right: 6px;
                    }

                    span {
                        font-family: DINPro, DINPro;
                        font-weight: 500;
                        font-size: 11px;
                        color: #FFFFFF;
                        line-height: 14px;
                        opacity: 0.5;
                        margin-left: 8px;
                    }
                }
            }

            .line {
                height: 1px;
                background: #FFFFFF;
                opacity: 0.1;
                margin-top: 23px;
                margin-bottom: 18px;
            }

            .home-card-b {
                display: flex;
                justify-content: space-between;

                >div {
                    flex: 1;
                }

                .home-card-b-title {
                    font-weight: 400;
                    font-size: 12px;
                    color: #FFFFFF;
                    line-height: 17px;
                    opacity: 0.5;
                }


                .home-card-b-number {
                    margin-top: 6px;

                    .num {
                        font-family: DINAlternate;
                        font-weight: bold;
                        font-size: 20px;
                        color: #FFFFFF;
                        line-height: 24px;
                    }

                    &.today {
                        font-family: DINAlternate, DINAlternate;
                        font-weight: bold;
                        font-size: 20px;
                        color: #E8FFB1;
                        line-height: 24px;
                    }


                    i {
                        margin-left: 6px;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 600;
                        font-size: 12px;
                        color: #9EA7B7;
                        line-height: 17px;
                        font-style: normal;
                    }
                }

            }
        }

        .home-share {
            background: url('../../assets/img/home/share-bg.png') no-repeat;
            background-size: 100% 100%;
            min-height: 44px;
            padding: 0 15px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 7px;

            &-l {
                display: flex;
                align-items: center;

                span {
                    font-weight: 600;
                    font-size: 13px;
                    color: #FFFFFF;
                    line-height: 18px;
                }

                img {
                    width: 24px;
                    height: 24px;
                    margin-right: 6px;
                }
            }

            &-r {
                display: flex;
                align-items: center;

                span {
                    font-weight: 400;
                    font-size: 12px;
                    color: #FFFFFF;
                    line-height: 17px;
                    opacity: 0.5;
                }

                img {
                    margin-left: 5px;
                    width: 10px;
                    height: 10px;
                }
            }
        }

        .home-card1 {
            display: flex;
            margin-top: 15px;

            >div {
                width: 167px;
                padding: 15px 18px;
                background: rgba(12, 15, 20, 0.32);
                border-radius: 20px;
                border: 1px solid rgba(255, 255, 255, 0.2);
                // opacity: 0.32;
            }

            >div+div {
                margin-left: 13px;
            }

            .title {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 2px;

                span {
                    font-weight: 400;
                    font-size: 12px;
                    color: #FFFFFF;
                    line-height: 17px;
                    opacity: 0.5;
                }

                img {
                    width: 14px;
                    height: 14px;
                }
            }

            .num {
                font-family: DINAlternate, DINAlternate;
                font-weight: bold;
                font-size: 30px;
                color: #FFFFFF;
                line-height: 35px;
            }

            .revenue {
                margin-top: 2px;
                font-weight: 400;
                font-size: 12px;
                color: #E8FFB1;
                line-height: 17px;

                span {
                    font-family: DINPro, DINPro;
                }
            }
        }

        .home-link {
            background: #0C0F14;
            border-radius: 20px;
            border: 1px solid rgba(255, 255, 255, 0.1);
            display: flex;
            align-items: center;
            padding: 15px;
            margin-top: 15px;

            &-l {
                width: 226px;
                height: 38px;
                background: #090B10;
                border-radius: 12px;
                border: 1px solid rgba(255, 255, 255, 0.1);
                font-size: 13px;
                color: #FFFFFF;
                line-height: 18px;
                height: 38px;
                display: flex;
                align-items: center;
                padding: 10px 12px;

                span {
                    color: rgba(0, 240, 255, 1);
                }
            }

            &-r {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 38px;
                background: #191B1F;
                border-radius: 12px;
                border: 1px solid rgba(255, 255, 255, 0.1);
                font-weight: 500;
                font-size: 13px;
                color: #FFFFFF;
                line-height: 18px;
                padding: 10px 14px;
                margin-left: 7px;

                >img {
                    width: 14px;
                    height: 14px;
                    margin-right: 14px;
                }
            }
        }

        .home-btn-box {
            display: flex;
            justify-content: space-between;
            margin-top: 19px;
            align-items: center;


            .btn-task {
                display: flex;
                align-items: center;
                justify-content: center;
                    cursor: pointer;

                >img {
                    width: 20px;
                    height: 20px;
                    margin-right: 8px;
                }

                font-weight: 500;
                font-size: 14px;
                color: #FFFFFF;
                line-height: 20px;
                width: 166px;
                height: 45px;
                background: #191B1F;
                border-radius: 16px;
                border: 1px solid rgba(255, 255, 255, 0.1);
            }

            .btn-revenue-box {
                margin-left: 13px;

            }

            .btn-revenue {
                display: flex;
                align-items: center;
                justify-content: center;
                    cursor: pointer;

                >img {
                    width: 20px;
                    height: 20px;
                    margin-right: 8px;
                }

                width: 166px;
                height: 45px;
                background: linear-gradient(180deg, #DAFE96 0%, #BDEF7C 100%);
                box-shadow: 0px 0px 8px 0px rgba(222, 255, 155, 0.6);
                border-radius: 16px;
                font-weight: 500;
                font-size: 14px;
                color: #000000;
                line-height: 20px;
            }
        }

        .home-list {
            width: 345px;
            background: #0C0F14;
            border-radius: 20px;
            border: 1px solid rgba(255, 255, 255, 0.1);
            padding: 14px 0;
            margin-top: 12px;

            .home-list-title {
                padding: 0 15px;
                display: flex;
                justify-content: space-between;

                span {
                    font-weight: 500;
                    font-size: 14px;
                    color: #FFFFFF;
                    line-height: 20px;
                }

                .link {
                    display: flex;
                    align-items: center;
                    font-weight: 400;
                    font-size: 12px;
                    color: #00F0FF;
                    line-height: 17px;

                    >img {
                        width: 12px;
                        height: 12px;
                        margin-left: 6px;
                    }
                }
            }

            .line {
                height: 1px;
                background: #FFFFFF;
                opacity: 0.1;
                margin-top: 15px;
                margin-bottom: 14px;
            }

            .home-list-item {
                padding: 0 15px;
                margin-bottom: 15px;
                display: flex;
                align-items: center;
                justify-content: space-between;

                &-l {
                    display: flex;
                    align-items: center;

                    >img {
                        width: 32px;
                        height: 32px;
                        margin-right: 10px;
                    }

                    .title {
                        font-size: 13px;
                        color: #FFFFFF;
                        line-height: 18px;
                    }

                    .time {
                        font-size: 11px;
                        color: #FFFFFF;
                        line-height: 16px;
                    }
                }

                &-r {
                    font-family: DINPro, DINPro;
                    font-weight: bold;
                    font-size: 14px;
                    color: #DEFF9B;
                    line-height: 18px;
                }
            }
        }
    }



}
</style>

<style lang="less">
@import './home.less';
</style>
